<template>
    <div class="notification_users">
        <b-row>
            <b-col>
                <button class="btn btn-md btn-block btn-outline-info waves-effect waves-themed" v-on:click="select_user">
                    <span  class="fal  fa-eject mr-1"></span>
                    Обрати користувачів
                </button>
            </b-col>
        </b-row>
        
        <div class="users_in">
            <div class="users_list mt-3">
                <ul class="user_list_to_insert">
                    <li v-for="(item,index) in inside_users" class="border cursor-pointer shadow-1 mt-1 mb-2" >
                        <user_block
                            del_triger="remove_customer_in_invoice"
                            :can_del="true"
                            :show_vacation=true
                            :key="item.id"
                            :user=item padding_class="pt-2 pl-2 pb-1">
                        </user_block>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import Users_list from "../../../../shared/users/users_list.vue";
import user_block from "../../../../shared/user/user_block/user_block.vue";

export default {
    name: "internal_notification",
    components: {user_block, Users_list},
    props : {
        doc : {
            type : Object
        }
    },
    
    data() {
        return {
            user_select_uniq : "intenal_user_permission",
        }
    },
    
    created() {
        EventBus.$on('remove_customer_in_invoice',this.remove_customer_in_invoice);
        EventBus.$on('selected_users', e => {
            if(e !== undefined && e.uniq === this.user_select_uniq) {
                this.push_selected_users(e.users);
            }
        });
        
    },
    
    methods : {
        
        push_selected_users(users) {
            this.doc.attached_adjust = [];
            users.map(user => {
                this.doc.attached_adjust.push(user);
            });
            EventBus.$emit('close_u_filter');
        },
        
        select_user() {
            EventBus.$emit('load_users_filter', {
                uniq    : this.user_select_uniq,
                active  : this.inside_users
            });
        },
        
        remove_customer_in_invoice(user) {
            let del_id = user.id;
            this.doc.attached_adjust = this.doc.attached_adjust.filter(user_in => {
                return parseInt(user_in.id) != parseInt(del_id);
            });
        },
        
    },
    
    computed : {
        inside_users () {
            if (this.doc.hasOwnProperty('attached_adjust')) {
                return this.doc.attached_adjust;
            }
            return [];
        }
    },
}
</script>


<style scoped>

</style>